import { useOutletContext } from 'react-router-dom';

/** Values the service plan item dashboard hands to its tab routes. */
export type ServicePlanItemTabContext = {
    isServicePlanItemActive?: boolean;
};

export const useServicePlanItemTabContext = (): ServicePlanItemTabContext =>
    useOutletContext<ServicePlanItemTabContext>();
